import React, { Component } from "react";
import { Button, Display3 } from "@sainsburys-tech/fable";
import WhenAuthorized from "../WhenAuthorized";
import * as roles from "../../utils/roles";
import { GridItem, Grid } from "@sainsburys-tech/fable";
import { Link } from "react-router-dom";
import OverridesList from "../OverridesList";
import { forkJoin, BehaviorSubject, combineLatest, timer } from "rxjs";
import { map, mergeMap } from "rxjs/operators";
import { componentFromStream } from "recompose";
import withLoadingAndErrorHandling from "../../utils/reactive/wrapPageApiCall.js";
import PropTypes from "prop-types";
import PageTitle from "../PageTitle";
import NoDataMessage from "../NoDataMessage";
import OverrideDiscardModal from "../OverrideDiscardModal";
import { Redirect } from "react-router-dom";
import { OverrideToastConsumer } from "../WithOverrideToastManager";
import { Event } from "../Tracking";
import "./OverridesPage.css";
import * as styles from "./OverridesPage.styles";

const Table = props => {
  if (props.data.length === 0)
    return (
      <div className="fable:text-center">
        <NoDataMessage
          title={"We couldn't find any overrides"}
          subtitle={
            "There are currently no overrides for stores. You can add an override by clicking 'add override'."
          }
        />
      </div>
    );

  return (
    <OverridesList
      data={props.data}
      onDiscardClick={props.onDiscardClick}
      onEditClick={props.onEdit}
    />
  );
};

class OverridesPage extends Component {
  state = {
    discardModalOpen: false,
    overrideToDiscard: null,
    overrideToEdit: null
  };

  handleDiscardModalClose = () => {
    this.closeDiscardDialog();
  };

  handleDiscardSuccess = () => {
    const override = this.state.overrideToDiscard;
    if (override) {
      this.props.toastManager.monitorOverrideStage(
        override.overrideId,
        override.name
      );
    }
    this.closeDiscardDialog();
    this.props.onDiscardSuccess();
  };

  closeDiscardDialog = () => {
    this.setState({ discardModalOpen: false, overrideToDiscard: null });
  };

  openDiscardDialog = override => {
    this.setState({ discardModalOpen: true, overrideToDiscard: override });
  };

  handleEdit = override => {
    this.setState({ overrideToEdit: override });
  };

  render() {
    if (this.state.overrideToEdit)
      return <Redirect to={`overrides/${this.state.overrideToEdit}/edit`} />;

    return (
      <PageTitle title="Lighting overrides">
        <div>
          <Grid cols={{ xl: 4, lg: 3, md: 3, sm: 3, xs: 5 }} gap="md" style={{ paddingBottom: '2rem' }}>
            <GridItem
              colSpan={{
                xl: 3,
                lg: 2,
                md: 2,
                sm: 2,
                xs: 3
              }}
            >
              <Display3 as="h3" style={styles.overridesHeading}>
                Overrides
              </Display3>
            </GridItem>
            <GridItem
              colSpan={{
                xl: 1,
                lg: 1,
                md: 1,
                sm: 1,
                xs: 2
              }}
              style={{ textAlign: 'right' }}
            >
              <WhenAuthorized roles={[roles.LIGHTING_OVERRIDES_WRITE]}>
                <Link
                  to={{
                    pathname: "/lighting/overrides/add"
                  }}
                >
                  <Button
                    isFullWidth
                    onClick={() =>
                      Event("Override Event", "Add Override", "(not set)")
                    }
                  >
                    Add override 
                  </Button>
                </Link>
              </WhenAuthorized>
            </GridItem>
          </Grid>
          <Table
            data={this.props.data}
            onDiscardClick={this.openDiscardDialog}
            onEdit={this.handleEdit}
          />
          <OverrideDiscardModal
            open={this.state.discardModalOpen}
            overrideId={
              this.state.overrideToDiscard
                ? this.state.overrideToDiscard.overrideId
                : null
            }
            onClose={this.handleDiscardModalClose}
            onDiscardSuccess={override => this.handleDiscardSuccess(override)}
          />
        </div>
      </PageTitle>
    );
  }
}
OverridesPage.propTypes = {
  data: PropTypes.array.isRequired
};

const mapOverrides = overrides => {
  return overrides.overrides.map(item => {
    return item;
  });
};

export default componentFromStream(props$ => {
  const fetchTrigger$ = new BehaviorSubject(null);

  const triggerFetch = () => {
    fetchTrigger$.next();
  };

  const refreshTimer$ = timer(0, 30000);
  return withLoadingAndErrorHandling(() =>
    combineLatest([props$, fetchTrigger$, refreshTimer$]).pipe(
      mergeMap(([props]) => forkJoin([props.getCurrentOverrides()])),
      map(([overrides]) => (
        <OverrideToastConsumer>
          {toastManagerContext => (
            <OverridesPage
              toastManager={toastManagerContext}
              data={mapOverrides(overrides)}
              onDiscardSuccess={triggerFetch}
            />
          )}
        </OverrideToastConsumer>
      ))
    )
  );
});
